<template>
    <div class="cards" :class="classForCardSet">
        <div v-for="card in this.cardset"
             class="card"
             v-bind:class="{ active: active(card) }"
             @click="handleClick(card)">
            {{ card }}
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    data() {
      return {
        set: 'fibonacci',
        cards: {
          fibonacci: ['0.5', '0', '1', '2', '3', '5', '8', '13', '20', '40', '100', '?'],
          tshirt: ['XS', 'S', 'M', 'L', 'XL', '?']
        }
      }
    },
    computed: {
      /**
       * @todo add option to switch cardset during session?
       */
      cardset() {
        return this.cards[this.set];
      },
      classForCardSet() {
        return {
          'card-set-fibonacci': this.set === 'fibonacci',
          'card-set-tshirt': this.set === 'tshirt',
          'disabled': this.state === 0
        }
      },
      ...mapState({
        votes: state => state.game.votes,
        state: state => state.game.state
      })
    },
    methods: {
      handleClick(card) {
        if (this.state === 0) {
          return;
        }
        return this.active(card)
          ? this.$store.dispatch('game/withdrawVote')
          : this.$store.dispatch('game/castVote', card)
      },
      active(card) {
        return this.$store.getters['game/vote'] === card
      }
    }
  }
</script>
<style scoped lang="scss">

    .cards {
        display: grid;
        grid-column-gap: 10px;
        grid-row-gap: 10px;
        justify-items: stretch;
        align-items: stretch;
        margin: 5px 0 15px 0;

        &.disabled {
            display: none;
            @media (min-width: 576px) {
                display: grid;
                opacity: 0.4;
            }
        }
    }

    .card-set-fibonacci {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr;
    }

    .card-set-tshirt {
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr;
    }

    .card {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 85px;

        font-family: monospace;
        position: relative;

        background: #fff;
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
        transition: all 0.3s ease-in-out;

        font-size: 1.8rem;

        &:hover {
            cursor: pointer;
        }

        &.active {
            box-shadow: 0 8px 22px rgba(0,0,0,0.25), 0 4px 8px rgba(0,0,0,0.22);
            background-color: #343a40;
            color: #fff;
        }
    }

</style>
